module.exports = __webpack_public_path__ + "img/ziliaoKu.39aac505.png";